import React, { useEffect, useState } from "react";
import queryString from "query-string";
import PropTypes from "prop-types";

function FiltersHolder(props) {
    const {
        brands,
        defaultBrand,
        type,
        defaultService,
        onSubmit,
        onSearchMap,
        findPlaceFromQueryError,
    } = props;

    const [brand, setBrand] = useState();
    const [service, setService] = useState();
    const [locationQuery, setLocationQuery] = useState();
    const [isPrefilled, setIsPrefilled] = useState(false);
    const queryParams = queryString.parse(window.location.search.substr(1), {
        arrayFormat: "comma",
    });

    // PREFILL BASED ON PARAMETERS
    useEffect(() => {
        let brandObj = { value: "" };
        if (queryParams.merk) {
            brandObj = { value: queryParams.merk };
        } else if (defaultBrand) {
            brandObj = { value: defaultBrand };
        }

        let serviceObj = { value: "" };
        if (queryParams.soort) {
            serviceObj = { value: queryParams.soort };
        } else if (defaultService) {
            serviceObj = { value: defaultService };
        }

        let locationQueryObj = { value: "" };
        if (queryParams.locationQuery) {
            locationQueryObj = { value: queryParams.locationQuery };
        }

        setBrand(brandObj);
        setService(serviceObj);
        setLocationQuery(locationQueryObj);
    }, []);

    // ON FILTERS UPDATE
    useEffect(() => {
        if (!brand || !service) {
            return;
        }
        // First time
        if (isPrefilled) {
            let newState = `${window.location.pathname}`;
            let separator = "?";

            if (brand.value) {
                newState += `${separator}merk=${brand.value}`;
                separator = "&";
            }

            if (service.value) {
                newState += `${separator}soort=${service.value}`;
            }

            window.history.pushState("", "", `${newState}`);
        } else {
            setIsPrefilled(true);
        }

        onSubmit(brand, service);
    }, [brand, service]);

    useEffect(() => {
        const timeOutId = setTimeout(
            () => onSearchMap(locationQuery.value),
            1500
        );
        return () => clearTimeout(timeOutId);
    }, [locationQuery]);

    function handleBrandChange(event) {
        const eventValue = event.target.value;
        setBrand({ value: eventValue });
    }

    function handleServiceChange(event) {
        const eventValue = event.target.value;
        setService({ value: eventValue });
    }

    function handleSubmit(event) {
        event.preventDefault();
        onSubmit(brand, service);
    }

    let searchField = null;
    let filters = null;

    if (locationQuery) {
        searchField = (
            <div className="field">
                <input
                    value={locationQuery.value}
                    onChange={(event) =>
                        setLocationQuery({ value: event.target.value })
                    }
                    className="input-alt"
                    aria-label={ss.i18n._t(
                        "EstablishmentApp.SEARCH_LOCATION_PLACEHOLDER"
                    )}
                    placeholder={ss.i18n._t(
                        "EstablishmentApp.SEARCH_LOCATION_PLACEHOLDER"
                    )}
                    type="text"
                />
                <div className="message error">{findPlaceFromQueryError}</div>
                {/* <div className="text-right">
                    <img src="/_resources/themes/schellevis/img/powered_by_google_on_white.png" width="144" height="18" alt="Powered by Google" className="hidden--gt-palm" />
                </div> */}
            </div>
        );
    }

    if (service) {
        filters = (
            <select
                value={service.value}
                onChange={handleServiceChange}
                aria-label={ss.i18n._t(
                    "EstablishmentApp.SELECT_SERVICE_PLACEHOLDER"
                )}
            >
                <option value="">
                    {ss.i18n._t("EstablishmentApp.SELECT_SERVICE_PLACEHOLDER")}
                </option>
                {type.map((option) => (
                    <option key={option} value={option}>
                        {ss.i18n._t(
                            `EstablishmentApp.SERVICE_LABEL_${option}`
                        ) || option}
                    </option>
                ))}
            </select>
        );
    }

    return (
        <div>
            <form className="form" onSubmit={handleSubmit}>
                <div className="title">
                    {ss.i18n._t("EstablishmentApp.SEARCH_LOCATION_HEADER")}
                </div>
                {searchField}
                <div className="title">
                    {ss.i18n._t("EstablishmentApp.FILTER_HEADER")}
                </div>
                {filters}
            </form>
        </div>
    );
}

FiltersHolder.propTypes = {
    brands: PropTypes.array,
    defaultBrand: PropTypes.string,
    type: PropTypes.array.isRequired,
    defaultService: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    onSearchMap: PropTypes.func.isRequired,
    findPlaceFromQueryError: PropTypes.string,
};

FiltersHolder.defaultProps = {
    defaultBrand: "",
    defaultService: "",
    findPlaceFromQueryError: null,
};

export default FiltersHolder;
